/**
 * @fileoverview > handler for the "/app_settings/create_api_key" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCreateApiKeyCacheKeys } from "./constants";
import type { PostAppSettingsCreateApiKeyProps, AppSettingsCreateApiKeyResult } from "./types";

export const postAppSettingsCreateApiKey = reactQueryMutationAdapter(
  appSettingsCreateApiKeyCacheKeys,
  (props: PostAppSettingsCreateApiKeyProps): Promise<AppSettingsCreateApiKeyResult> => {
    return fetch("/app_settings/create_api_key", "POST", props);
  }
);
